const insta = process.env.PUBLIC_URL + "/assets/insta.png";
const whatsapp = process.env.PUBLIC_URL + "/assets/whatsapp.png";



export const contactLinks = [
  { name: 'Instagram', url: insta, link: 'https://www.instagram.com/geethafurniture6/' },
  { name: 'Whatsapp', url: whatsapp, link: 'https://wa.me/9080420080' },
];

